<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title base-index-title">{{ title }}</h4>

          <md-card-actions class="text-right md-alignment-right btn-index-add">
            <router-link :to="{ name: 'NewsCreateForm' }">
              <md-button native-type="submit" class="md-primary"
                >{{ $t("common.add") }}
              </md-button>
            </router-link>
          </md-card-actions>
        </md-card-header>
        <md-card-content>
          <base-search-form
            :formSearch="formSearch"
            @search="changePage"
            @exportExcel="exportExcel"
            :enableExport="enableExport"
          />
          <news-table
            :tableData="tableData"
            :pagination="pagination"
            :columns="columns"
            @confirmDelete="confirmDelete"
            :hideAction="hideAction"
          >
          </news-table>
        </md-card-content>
        <base-pagination :pagination="pagination" @changePage="changePage" />
      </md-card>
    </div>
  </div>
</template>

<script>
import { BasePagination, BaseSearchForm } from "@/components/Base/index.js";

import Swal from "sweetalert2";
import { ExportService } from "../../services/export.service";
import formatDateTime from "@/core/utils/formatTime";
import { NewsService } from "../../services/news.service";
import NewsTable from "./NewsTable";

export default {
  name: "NewsIndex",
  data() {
    return {
      pagination: {
        perPage: 10,
        from: 0,
        to: 0,
        total: 0,
        currentPage: 0
      },
      tableData: [],
      params: {},
      modal: {
        show: false,
        action: "view"
      },
      modalAdd: {
        show: false
      }
    };
  },
  props: [
    "path",
    "formSearch",
    "columns",
    "enableExport",
    "title",
    "hideAction",
    "serviceName"
  ],
  components: { NewsTable, BasePagination, BaseSearchForm },
  mounted() {
    this.getTableData();
  },
  methods: {
    async getTableData() {
      const response = await new NewsService().getList(this.params);

      let tableData = response.data;
      tableData.forEach(function(news) {
        news.created_at = news.created_at
          ? formatDateTime(news.created_at)
          : "";
        news.updated_at = news.updated_at
          ? formatDateTime(news.updated_at)
          : "";
        news.category_name = news.news_category ? news.news_category.name : "";
      });
      this.tableData = tableData;
      this.pagination.perPage = response.per_page;
      this.pagination.currentPage = response.current_page;
      this.pagination.total = response.total;
      this.pagination.from = response.from;
      this.pagination.to = response.to;
      return this.tableData;
    },
    changePage(params) {
      this.params.page = this.pagination.currentPage;
      this.params.limit = this.pagination.perPage;
      this.params = { ...this.params, ...params };
      this.getTableData();
    },
    closeModal() {
      this.modal.show = false;
      this.modalAdd.show = false;
      this.$store.commit("DESTROY_MODAL");
    },
    async delete(id) {
      const response = await new NewsService().delete(id);
      if (!response) {
        return;
      }
      await Swal.fire({
        title: "Deleted!",
        text: `You deleted ${id}`,
        type: "success",
        confirmButtonClass: "md-button md-success btn-fill",
        buttonsStyling: false
      });
      // Reload table data
      await this.getTableData();
    },
    confirmDelete(data) {
      Swal.fire({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.delete(data.id);
        }
      });
    },
    notify(message, type = "success", title = "Notification") {
      this.$notify({
        message: message,
        type: type,
        title: title,
        text: message
      });
    },
    exportExcel() {
      ExportService.exportExcel(this.path, this.params);
    }
  },
  computed: {
    currentRoutePath() {
      return this.$route.path;
    }
  }
};
</script>
<style scoped>
.md-card .md-card-actions {
  border: none;
  margin-top: 15px;
}
</style>
